"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDocumentDefinitions(definitions) {
    var operationDefinition = undefined;
    var fragmentMap = {};
    for (var _i = 0, definitions_1 = definitions; _i < definitions_1.length; _i++) {
        var definition = definitions_1[_i];
        switch (definition.kind) {
            case "OperationDefinition":
                operationDefinition = definition;
                break;
            case "FragmentDefinition":
                fragmentMap[definition.name.value] = definition;
                break;
            default:
                throw new Error("This is not an executable document");
        }
    }
    var rootFieldNode = {
        kind: "Field",
        name: {
            kind: "Name",
            value: "data"
        },
        selectionSet: {
            kind: "SelectionSet",
            selections: operationDefinition.selectionSet.selections
        }
    };
    return [fragmentMap, rootFieldNode];
}
exports.getDocumentDefinitions = getDocumentDefinitions;
function expandFragments(selectionNodes, fragmentMap) {
    var fieldNodes = [];
    for (var _i = 0, selectionNodes_1 = selectionNodes; _i < selectionNodes_1.length; _i++) {
        var selectionNode = selectionNodes_1[_i];
        switch (selectionNode.kind) {
            case "Field":
                fieldNodes.push(selectionNode);
                break;
            case "InlineFragment":
                fieldNodes.push.apply(fieldNodes, expandFragments(selectionNode.selectionSet.selections, fragmentMap));
                break;
            case "FragmentSpread":
                var fragment = fragmentMap[selectionNode.name.value];
                fieldNodes.push.apply(fieldNodes, expandFragments(fragment.selectionSet.selections, fragmentMap));
                break;
            default:
                throw new Error("Unknown selection node field kind: " + selectionNode.kind);
        }
    }
    return fieldNodes;
}
exports.expandFragments = expandFragments;
function fieldNameWithArguments(fieldNode, variables) {
    // tslint:disable-next-line:readonly-keyword
    var argumentsObject = {};
    // tslint:disable-next-line:no-arguments
    for (var _i = 0, _a = fieldNode.arguments; _i < _a.length; _i++) {
        var argumentNode = _a[_i];
        argumentsObject[argumentNode.name.value] = resolveValueNode(argumentNode.value, variables);
    }
    var hashedArgs = JSON.stringify(argumentsObject);
    return fieldNode.name.value + "(" + hashedArgs + ")";
}
exports.fieldNameWithArguments = fieldNameWithArguments;
function resolveValueNode(valueNode, variables) {
    switch (valueNode.kind) {
        case "Variable":
            return variables[valueNode.name.value];
        case "NullValue":
            return null;
        case "ListValue":
            return valueNode.values.map(function (f) { return resolveValueNode(f, variables); });
        case "ObjectValue":
            // tslint:disable-next-line:readonly-keyword
            var valueObject = {};
            for (var _i = 0, _a = valueNode.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                valueObject[field.name.value] = resolveValueNode(field.value, variables);
            }
            return valueObject;
        default:
            return valueNode.value;
    }
}
exports.defaultGetObjectId = function (object) {
    if (object.__typename === undefined) {
        throw new Error("Required field __typename is missing");
    }
    return object.id === undefined
        ? undefined
        : object.__typename + ";" + object.id;
};
/**
 * Evaluates  @skip and @include directives on field
 * and returns true if the node should be included.
 */
function shouldIncludeField(directives, variables) {
    if (variables === void 0) { variables = {}; }
    var finalInclude = true;
    for (var _i = 0, directives_1 = directives; _i < directives_1.length; _i++) {
        var directive = directives_1[_i];
        var directiveInclude = true;
        if (directive.name.value === "skip" || directive.name.value === "include") {
            if (directive.arguments) {
                for (var _a = 0, _b = directive.arguments; _a < _b.length; _a++) {
                    var arg = _b[_a];
                    if (arg.name.value === "if") {
                        var argValue = void 0;
                        if (arg.value.kind === "Variable") {
                            argValue = variables && !!variables[arg.value.name.value];
                        }
                        else if (arg.value.kind === "BooleanValue") {
                            argValue = arg.value.value;
                        }
                        else {
                            // The if argument must be of type Boolean!
                            // http://facebook.github.io/graphql/June2018/#sec--skip
                            throw new Error("The if argument must be of type Boolean!, found '" + arg.value.kind + "'");
                        }
                        var argInclude = directive.name.value === "include" ? argValue : !argValue;
                        directiveInclude = directiveInclude && argInclude;
                    }
                }
            }
            finalInclude = finalInclude && directiveInclude;
        }
    }
    return finalInclude;
}
exports.shouldIncludeField = shouldIncludeField;
//# sourceMappingURL=functions.js.map